---
title: Saturator
description: "A saturator device: four curves, a drive, a mix and an output, a panel that draws the transfer curve, a Web Audio engine and tools for agents."
component: true
base: base
---

<ComponentPreview styleName="base-nova" name="block-saturator" />

Adds warmth or dirt. The drive pushes the signal into one of four curves: a soft clip, a hard clip, a wavefold or an asymmetric tube. It is a [device](/docs/devices): a state, a panel, an engine and tools, each its own file.

## Installation

<Install name="saturator" kind="device" />

## Controls

<DeviceControls device="saturator">
<Control id="curve">The shape of the saturation.</Control>
<Control id="driveDb">How hard the signal is pushed into the curve.</Control>
<Control id="mix">The balance of the saturated signal and the clean one.</Control>
<Control id="outputDb">The level of the output.</Control>
</DeviceControls>

## Panel

The panel draws the transfer curve against the straight line of a clean sound. `saturate(curve, input)` is one curve and `saturatorCurve(state)` is the whole transfer curve with the mix and the output.

<DeviceUsage name="saturator" />

## Engine

Create it, connect it and update it as for any device: see [The engine](/docs/devices#the-engine).

The drive is a gain before the table of the curve, so turning it never rebuilds the table. Only picking another curve does. The shaper oversamples 4x to keep the clip from aliasing, which is the [latency](/docs/devices#latency) of the device.
